import { render, staticRenderFns } from "./Spoergsmaal.vue?vue&type=template&id=f47b4ef0&"
import script from "./Spoergsmaal.vue?vue&type=script&lang=js&"
export * from "./Spoergsmaal.vue?vue&type=script&lang=js&"
import style0 from "./Spoergsmaal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
